import {ChangeDetectorRef, Component, Input, OnInit, ViewChild} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {NotifierWrapService} from '../../../services/notifier-wrap.service';
import {NzMarks} from 'ng-zorro-antd/slider';
import {Chat, IMessengerConnector} from '../../../types/all.type';
import {AllService} from '../../../services/all.service';
import {InterfaceService} from '../../../services/interface.service';
import {NgxModalDraggableDirective} from '../../../directives/draggable.directive';
import {DcService} from '../../../services/dc.service';

@Component({
  selector: 'app-modal-notify-settings',
  templateUrl: './modal-notify-settings.component.html',
  styleUrls: ['./modal-notify-settings.component.scss']
})
export class ModalNotifySettingsComponent implements OnInit {
  saveTimeout: NodeJS.Timeout;
  @Input() Service: IMessengerConnector;
  @Input() chat: Chat;
  arSettings: any = {};
  timeVal = 0;
  public isLoaded = false;
  currentTimestamp: number = Date.now();

  marks: NzMarks = {
    0: '1ч',
    10: '3ч',
    20: '6ч',
    65: '1д',
    80: '3д',
    100: {
      style: {
        color: '#f50',
        marginLeft: '-20px'
      },
      label: '<strong>Всегда</strong>'
    }
  };
  public modalDirective: NgxModalDraggableDirective;
  @ViewChild(NgxModalDraggableDirective)
  set setDirective(directive: NgxModalDraggableDirective) {
    this.modalDirective = directive;
  }
  constructor(
    private dcService: DcService,
    public interfaceService: InterfaceService,
    private cd: ChangeDetectorRef,
    public allService: AllService,
    public notifierWrapService: NotifierWrapService,
    public bsModalRef: BsModalRef
  ) {
  }

  ngOnInit(): void {
    this.getNotifySettings();
  }

  timeChange(val) {
    let time = Date.now();
    switch (val) {
      case 0:
        time = time + 60 * 60 * 1000;
        break;
      case 10:
        time = time + 60 * 60 * 3 * 1000;
        break;
      case 20:
        time = time + 60 * 60 * 6 * 1000;
        break;
      case 65:
        time = time + 60 * 60 * 24 * 1000;
        break;
      case 80:
        time = time + 60 * 60 * 24 * 3 * 1000;
        break;
      case 100:
        time = time + 60 * 60 * 24 * 365 * 5 * 1000;
        break;
    }
    clearTimeout(this.saveTimeout);
    this.saveTimeout = setTimeout(() => {
      this.Service.setNotify({
        peer: this.chat.id,
        mute_until: Math.round(time / 1000),
        type: this.chat.service_type
      }).subscribe(
        (result: any) => {
          this.setMuteChatItem(Math.round(time / 1000));
          const timeText = typeof this.marks[val] === 'object' ? 'всегда' : this.marks[val];
          this.notifierWrapService.notify('info', 'Уведомения отключены на ' + timeText);
          this.arSettings.mute_until = Math.round(time / 1000);
          this.cd.detectChanges();
        },
        (e) => {
          this.interfaceService.errorHandling(e);
        }
      );
    }, 1500);
  }

  setMuteChatItem(val = 0) {
    this.chat.mute_until = val;
    const chat = this.allService.arChat.find((v: Chat) => v.id === this.chat.id);
    if (chat) {
      chat.mute_until = val;
      this.allService.saveLocalChats$.next();
      this.dcService.detectChanges$.next('chat-list');
    }
  }

  enable() {
    this.isLoaded = false;
    this.Service.setNotify({
      peer: this.chat.id,
      mute_until: 0,
      type: this.chat.service_type
    }).subscribe(
      (result: any) => {
        this.setMuteChatItem(0);
        this.bsModalRef.hide();
        this.notifierWrapService.notify('success', 'Уведомения включены');
      },
      (e) => {
        this.interfaceService.errorHandling(e);
      }
    );
  }

  getNotifySettings(): void {
    this.Service.getNotify(this.chat.id, this.chat).subscribe(
      (result: any) => {
        this.arSettings = result;
        this.isLoaded = true;
      },
      (e) => {
        this.interfaceService.errorHandling(e);
      }
    );
  }
}
